// extracted by mini-css-extract-plugin
export var headerCell = "_63-1";
export var loadingSpinnerContainer = "_63-4";
export var loadingStateCell = "_63-5";
export var rowWrapper = "_63-3";
export var standaloneTable = "_63-6";
export var table = "_63-0";
export var white = "_63-2";